<template>
  <div>
    <isHeader ref="isHeader" />
    <div
      ref="scrollBox"
      style="height: 100vh; overflow-y: auto; overflow-x: hidden"
    >
      <commonTop
        :info="{
          title: '智慧导检系统',
          desc: '方便健康中心导诊人员为受检者提供全流程服务，有利于构建健康管理中心动态化、高效能的运营模式，提升参检人员的受检体验，增强服务黏性，实现智慧医疗服务商线上线下相结合',
        }"
        :img="require('@/assets/xuwei/AOB07615.jpg')"
      >
        <!-- 插槽 -->
        <!-- <button>在线咨询</button> -->
        <button @click="$store.commit('changeAppointModal', true)">
          预约体验
        </button>
      </commonTop>
      <!--  -->
      <isTab current="智慧导检系统" :info="info" />
      <isFooter />
    </div>
  </div>
</template>

<script>
import isHeader from "@/components/header/index.vue";
import isFooter from "@/components/footer/index.vue";
import commonTop from "@/components/commonTop/index.vue";
import isTab from "@/components/ProductTab/tab.vue";
export default {
  name: "SmartInspection",
  data() {
    return {
      info: {
        partOne: {
          title: "产品设计理念",
          sub: "通过信息化手段精简受检者健康评估、套餐预订以及指引单打印等流程",
          swiper: [
            {
              bg: require("@/assets/xuwei/摄影图-医疗健康-DSC_6587.jpg"),
              showBgMark: true,
              icon: `
                           <svg width="100%" height="100%" viewBox="0 0 78 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M57.5761 19.0013H53.9843V16.3691C53.9843 12.2079 50.5779 8.82129 46.3923 8.82129H31.5494C27.3638 8.82129 23.9588 12.2279 23.9588 16.415V19.0013H20.3671C14.5134 19.0013 9.75244 23.7638 9.75244 29.6174V59.7242C9.75244 65.5762 14.5134 70.3387 20.3671 70.3387H57.5761C63.4297 70.3387 68.1907 65.5762 68.1907 59.7242V29.6174C68.1907 23.7637 63.4297 19.0013 57.5761 19.0013ZM28.4228 16.415C28.4228 14.6888 29.8262 13.2869 31.5494 13.2869H46.3923C48.146 13.2869 49.5204 14.6397 49.5204 16.3691V19.0013H28.4228V16.415ZM63.7266 59.7241C63.7266 63.1153 60.9674 65.8745 57.5761 65.8745H20.3671C16.9757 65.8745 14.2166 63.1153 14.2166 59.7241V29.6174C14.2166 26.2261 16.9757 23.4669 20.3671 23.4669H57.5761C60.9674 23.4669 63.7266 26.2261 63.7266 29.6174V59.7241ZM48.5884 39.6565H43.9851V35.0517C43.9851 33.7019 42.8801 32.597 41.5303 32.597H36.4129C35.0631 32.597 33.9582 33.7018 33.9582 35.0517V39.6565H29.3549C28.0036 39.6565 26.8986 40.7614 26.8986 42.1127V47.2271C26.8986 48.5784 28.0035 49.6834 29.3549 49.6834H33.9582V54.2882C33.9582 55.6379 35.0631 56.7429 36.4129 56.7429H41.5303C42.8801 56.7429 43.9851 55.6379 43.9851 54.2882V49.6834H48.5884C49.9397 49.6834 51.046 48.5784 51.046 47.2271V42.1127C51.046 40.7614 49.9397 39.6565 48.5884 39.6565Z" fill="white"/>
</svg>

                            `,
              name: "动态高效的经营模式",
            },
            {
              bg: require("@/assets/xuwei/5e9c83924b776.jpg"),
              showBgMark: true,
              icon: `
                          <svg width="100%" height="100%" viewBox="0 0 78 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_508_1705)">
<path d="M39.1186 78.4241C31.4201 78.4241 23.8946 76.1413 17.4936 71.8643C11.0926 67.5873 6.10357 61.5082 3.15751 54.3957C0.211445 47.2833 -0.559379 39.457 0.942511 31.9065C2.4444 24.356 6.15155 17.4204 11.5952 11.9768C17.0388 6.53314 23.9744 2.82599 31.5249 1.3241C39.0754 -0.177788 46.9017 0.593037 54.0141 3.5391C61.1266 6.48516 67.2057 11.4741 71.4827 17.8752C75.7597 24.2762 78.0425 31.8017 78.0425 39.5002C78.0425 39.9694 77.8561 40.4194 77.5243 40.7512C77.1925 41.083 76.7425 41.2694 76.2733 41.2694C75.804 41.2694 75.354 41.083 75.0222 40.7512C74.6904 40.4194 74.504 39.9694 74.504 39.5002C74.504 32.5016 72.4287 25.6602 68.5405 19.8411C64.6523 14.022 59.1258 9.48653 52.66 6.80829C46.1941 4.13005 39.0793 3.4293 32.2152 4.79465C25.3511 6.16001 19.046 9.53015 14.0973 14.4789C9.14855 19.4276 5.77842 25.7327 4.41306 32.5968C3.04771 39.4609 3.74846 46.5757 6.4267 53.0416C9.10494 59.5074 13.6404 65.0339 19.4595 68.9221C25.2786 72.8103 32.12 74.8856 39.1186 74.8856C39.5878 74.8856 40.0378 75.072 40.3696 75.4038C40.7014 75.7356 40.8878 76.1856 40.8878 76.6549C40.8878 77.1241 40.7014 77.5741 40.3696 77.9059C40.0378 78.2377 39.5878 78.4241 39.1186 78.4241Z" fill="white"/>
<path d="M36.3762 50.7528C35.9942 50.7479 35.624 50.6194 35.321 50.3866C35.018 50.1538 34.7985 49.8291 34.6954 49.4612L28.503 27.54L22.6644 40.2345C22.5223 40.546 22.2929 40.8096 22.004 40.9933C21.715 41.177 21.379 41.273 21.0366 41.2695H1.76927C1.30003 41.2695 0.85001 41.0831 0.518208 40.7513C0.186405 40.4195 0 39.9695 0 39.5002C0 39.031 0.186405 38.581 0.518208 38.2492C0.85001 37.9174 1.30003 37.731 1.76927 37.731H19.9043L27.2822 21.7102C27.4345 21.377 27.6866 21.0994 28.0035 20.9156C28.3204 20.7317 28.6866 20.6508 29.0514 20.684C29.4123 20.712 29.7559 20.85 30.0359 21.0794C30.3159 21.3087 30.5188 21.6185 30.6172 21.9668L36.5001 42.7911L39.7201 32.5382C39.8298 32.1886 40.0454 31.8817 40.3369 31.6599C40.6285 31.438 40.9817 31.3122 41.3479 31.2997C41.7078 31.2946 42.0606 31.3995 42.3594 31.6002C42.6581 31.801 42.8885 32.088 43.0198 32.4232L45.1164 37.731H59.5625C60.0318 37.731 60.4818 37.9174 60.8136 38.2492C61.1454 38.581 61.3318 39.031 61.3318 39.5002C61.3318 39.9695 61.1454 40.4195 60.8136 40.7513C60.4818 41.0831 60.0318 41.2695 59.5625 41.2695H43.8691C43.5127 41.2685 43.1649 41.1598 42.8713 40.9577C42.5777 40.7557 42.352 40.4697 42.2237 40.1372L41.5513 38.3679L38.0393 49.5055C37.9292 49.8623 37.709 50.1751 37.4103 50.3992C37.1116 50.6232 36.7496 50.747 36.3762 50.7528ZM54.0336 68.649C51.9739 68.646 49.9571 68.061 48.2156 66.9612C46.4742 65.8615 45.0791 64.2919 44.1912 62.4334C43.3033 60.575 42.9589 58.5034 43.1975 56.4577C43.4362 54.4119 44.2483 52.4753 45.5402 50.8712C46.832 49.267 48.551 48.0608 50.4989 47.3914C52.4467 46.7221 54.5441 46.6171 56.5491 47.0883C58.5541 47.5596 60.385 48.5881 61.8307 50.055C63.2764 51.522 64.278 53.3678 64.72 55.3794C65.3397 58.2014 64.8165 61.154 63.2647 63.5911C61.7129 66.0282 59.259 67.7514 56.4398 68.3836C55.6499 68.5601 54.8429 68.6491 54.0336 68.649ZM54.0336 50.3282C52.5034 50.3283 51.0111 50.8036 49.7628 51.6884C48.5144 52.5732 47.5717 53.8239 47.0647 55.2675C46.5578 56.7112 46.5117 58.2767 46.9328 59.7478C47.3539 61.2188 48.2214 62.5227 49.4155 63.4795C50.6096 64.4362 52.0713 64.9985 53.5988 65.0887C55.1262 65.179 56.644 64.7926 57.9424 63.983C59.2408 63.1735 60.2558 61.9807 60.8471 60.5695C61.4384 59.1582 61.5768 57.5982 61.2433 56.1049C60.8827 54.468 59.9742 53.0032 58.668 51.9528C57.3618 50.9023 55.7362 50.3292 54.0601 50.3282H54.0336Z" fill="white"/>
<path d="M60.0271 61.9997C61.1471 60.6453 62.3843 60.5281 63.7386 61.6482L76.4596 72.1681C77.8139 73.2881 77.9311 74.5253 76.8111 75.8796C75.691 77.234 74.4539 77.3512 73.0995 76.2311L60.3786 65.7112C59.0242 64.5912 58.907 63.354 60.0271 61.9997Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_508_1705">
<rect width="78" height="78" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>


                            `,
              name: "流程精简提升体验",
            },
          ],
        },
        partTwo: {
          title: "产品功能介绍",
          sub: "为健康管理中心提供更多执业场景，为患者提供便利，提升医院美誉度",
          list: [
            {
              title: "提升受检体验与受检者黏性",
              desc: "提升参检人员的受检体验，增强服务黏性，实现智慧医疗服务商线上线下相结合。",
            },
            // {
            //   title: "随访方案管理",
            //   desc: "定制化的随访路径设置，精细化、科学化的随访管理，科室化的随访结果统计与数据分析。",
            // },
          ],
          right_img: require("@/assets/SmartInspection/product.png"),
        },
      },
    };
  },
  mounted() {
    let that = this;
    this.$refs.scrollBox.addEventListener("scroll", function (e) {
      if (e.target.scrollTop > 80) {
        that.$refs.isHeader.setScrollBg(true);
      } else {
        that.$refs.isHeader.setScrollBg(false);
      }
    });
  },
  components: {
    commonTop,
    isHeader,
    isFooter,
    isTab,
  },
};
</script>

<style></style>
